var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateRangePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 5.66675V3.54175H12.7501V4.25008H11.3334V3.54175H5.66675V4.25008H4.25008V3.54175H2.83341V5.66675H14.1667ZM14.1667 7.08341H2.83341V14.1667H14.1667V7.08341ZM12.7501 2.12508H14.1667C14.9492 2.12508 15.5834 2.75934 15.5834 3.54175V14.1667C15.5834 14.9492 14.9492 15.5834 14.1667 15.5834H2.83341C2.05101 15.5834 1.41675 14.9492 1.41675 14.1667V3.54175C1.41675 2.75934 2.05101 2.12508 2.83341 2.12508H4.25008V1.41675H5.66675V2.12508H11.3334V1.41675H12.7501V2.12508ZM6.37508 9.91675H4.95841V8.50008H6.37508V9.91675ZM9.20841 9.91675H7.79175V8.50008H9.20841V9.91675ZM12.0417 9.91675H10.6251V8.50008H12.0417V9.91675ZM6.37508 12.7501H4.95841V11.3334H6.37508V12.7501ZM9.20841 12.7501H7.79175V11.3334H9.20841V12.7501Z",
    fill: "#292A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 5.66675V3.54175H12.7501V4.25008H11.3334V3.54175H5.66675V4.25008H4.25008V3.54175H2.83341V5.66675H14.1667ZM14.1667 7.08341H2.83341V14.1667H14.1667V7.08341ZM12.7501 2.12508H14.1667C14.9492 2.12508 15.5834 2.75934 15.5834 3.54175V14.1667C15.5834 14.9492 14.9492 15.5834 14.1667 15.5834H2.83341C2.05101 15.5834 1.41675 14.9492 1.41675 14.1667V3.54175C1.41675 2.75934 2.05101 2.12508 2.83341 2.12508H4.25008V1.41675H5.66675V2.12508H11.3334V1.41675H12.7501V2.12508ZM6.37508 9.91675H4.95841V8.50008H6.37508V9.91675ZM9.20841 9.91675H7.79175V8.50008H9.20841V9.91675ZM12.0417 9.91675H10.6251V8.50008H12.0417V9.91675ZM6.37508 12.7501H4.95841V11.3334H6.37508V12.7501ZM9.20841 12.7501H7.79175V11.3334H9.20841V12.7501Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRangePicker);
export default __webpack_public_path__ + "static/media/date-range-picker.13aea01d74712c86781d8e886e2e55ce.svg";
export { ForwardRef as ReactComponent };